document.addEventListener('DOMContentLoaded', () => {

  // Clubs & countries with multiple words
  const phrases = [
    "Manchester United",
    "Manchester City",
    "Real Madrid",
    "Atletico Madrid",
    "Bayern Munich",
    "Borussia Dortmund",
    "Paris Saint-Germain",
    "Inter Milan",
    "AC Milan",
    "Juventus",
    "Tottenham Hotspur",
    "West Ham",
    "Newcastle United",
    "Leeds United",
    "Sheffield United",
    "Nottingham Forest",
    "Queens Park Rangers",
    "Sporting CP",
    "Sporting Lisbon",
    "Ajax Amsterdam",
    "PSV Eindhoven",
    "Bayer Leverkusen",
    "RB Leipzig",
    "South Korea",
    "North Korea",
    "Saudi Arabia",
    "Costa Rica",
    "New Zealand",
    "Czech Republic",
    "United States"
  ];

  document.querySelectorAll('form[action*="/search"]').forEach(form => {

    form.addEventListener('submit', function () {

      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      let query = input.value.trim();

      if (!query || query.includes('"')) return;

      // Common aliases
const aliases = {
  "Man Utd": "Manchester United",
  "Man United": "Manchester United",
  "Man City": "Manchester City",
  "Atleti": "Atletico Madrid",
  "Spurs": "Tottenham Hotspur",
  "Barca": "Barcelona",
  "Juve": "Juventus",
  "BVB": "Borussia Dortmund",
  "Arcteryx": "Arc'teryx",
  "CP": "CP Company",
  "CDG": "Comme Des Garcons",
  "YSL": "Yves Saint Laurent",
  "Holland": "Netherlands",
  "Lyon": "Olympique Lyonnais",
  "United States": "USA",
  "Paris Saint Germain": "PSG",
  "Hamburg": "Hamburger"
};

// Replace aliases
Object.keys(aliases).forEach(function(alias) {
  const regex = new RegExp(alias, "gi");
  query = query.replace(regex, aliases[alias]);
});

      // Protect known phrases
      phrases.forEach(phrase => {
        const regex = new RegExp(phrase, 'gi');
        query = query.replace(regex, phrase.replace(/ /g, '__SPACE__'));
      });

      let words = query.split(/\s+/).map(word => {

        word = word.replace(/__SPACE__/g, ' ');

        return `"${word}"`;

      });

      input.value = words.join(' ');

    });

  });

});

// Remove visible quotes after the search page loads
window.addEventListener("load", function () {

  // Remove quotes from search input
  document.querySelectorAll('input[name="q"]').forEach(function(input) {
    input.value = input.value.replace(/"/g, "");
  });

  // Remove quotes from headings/text
  document.querySelectorAll("h1,h2,h3,h4,p,span").forEach(function(el) {

    if (el.children.length) return;

    if (el.textContent.includes('"')) {
      el.textContent = el.textContent.replace(/"/g, "");
    }

  });

});